import './Style/Card.css'
import FoodIllustation from './../Image/FoodIllustation.jpg';
import {useEffect} from 'react';
export default function Card({id,image=FoodIllustation,name="RecipeName",rating,preptime,mealtype,servings,key}){
    useEffect(()=>{
        console.log(`recipe:${name} of id = ${id} displayed successfully`);
    },[name,id]);
    return(
        <>
        <div id="card" title={`${name}`}>
            <div className='image'>
                <img alt={name} src={image} height="100%" width="100%" ></img>
            </div>
            <p id="name">{name} </p>
            {preptime?<p id="preptime">Prep Time:{preptime} mins</p>:null}
            {servings && <p id="serving">Serves:{servings}</p>}
            {mealtype && <p id="mealtype">Meal Type:{mealtype}</p>}
            {rating ? <p id="rating">Rating:{rating} ⭐</p> : null}
        </div>
        </>
    )
}